export default {
  applyChangeCity: '/courier/api/h5/v2/recruits/applyChangeCityNew',
  itemCheckV2: '/v3/recruit/changeCity/itemCheckV2',
  enable: '/clientEcosys/city/enable',
  activationScoreEnable: '/activationScore/client/enable',
  changeCityLimit: '/v3/recruit/changeCity/changeCityLimit',
  status: '/v3/awardcenter/flexibleTimeTask/status'
}
